

<div class="vx-alerts">
  <app-alert *ngFor="let alert of alerts" [alert]="alert">
    {{ alert.message }}
  </app-alert>
</div>

<app-loader *ngIf="showLoader"></app-loader>
<router-outlet />
